










































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import UpdatePricingModelTrigger from './UpdatePricingModelTrigger.coffee'

settings =
  name: 'UpdatePricingModelTriggerModal'

  vue:
    props: ['resourceComponent', 'resourceKey']
    components: { Modal, RequestButton }
    mixins: [UpdatePricingModelTrigger.trigger()]

    data: ->
      takeType: 'cents'
      min_purchase_in_dollars: null

    computed:
      modalConfig: -> @modal?.config
      pricingModel: -> @modalConfig?.pricing_model || {}
      pricing: -> @modal?.data?.pricing || {}

    methods:
      modalData: ->
        @initialize()
        {
          pricing: { ...@modalConfig.pricing }
        }

      initialize: ->
        @takeType = if @modalConfig.pricing.take_percentage > 0 then 'percentage' else 'cents'
        @min_purchase_in_dollars = parseInt((@modalConfig.pricing.min_purchase_in_cents || 0) / 100)

      hiSave: ->
        if @takeType is 'cents'
          @pricing.take_percentage = null
        else
          @pricing.take_in_cents = null

        @pricing.min_purchase_in_cents = parseInt(@min_purchase_in_dollars) * 100 if @pricing.style is 'marketplace'
        @execute()

    watch:
      modalConfig: ->
        @initialize()

export default VueOptions.vue settings
